export default function NotificationsTable({
  notifications = [],
  columns = [],
  emptyMessage = "No notifications have been recorded yet.",
  getTextColorClass = () => "",
}) {
  // Check if data is empty
  const isEmpty = notifications.length === 0

  return (
    <div className="bg-tableau-bg rounded-xl overflow-hidden shadow-sm border border-tableau-border">
      <table className="w-full border-collapse">
        <thead className="bg-tableau-header border-b border-tableau-border">
          <tr className="text-left">
            {columns.map((column) => (
              <th
                key={column.key}
                className={`py-3 px-4 font-medium text-gray-700 ${column.headerClassName || ""}`}
                style={{ width: column.width || "auto" }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-gray-500 font-normal">
          {isEmpty ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-6 bg-tableau-bg1">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            notifications.map((notification, index) => (
              <tr key={notification.id} className={index % 2 === 0 ? "bg-tableau-bg1" : "bg-tableau-bg"}>
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={`py-4 px-4 ${
                      column.key === "studyName" || column.key === "type" ? getTextColorClass(notification.type) : ""
                    }`}
                  >
                    {notification[column.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
